import { wrapReducer } from "@client/content/lib/helper";
import { type FailureActionData } from "@client/lib/actions";
import { Status } from "@client/types";
import { type ReduxAction } from "@client/types/ReduxAction";
import { Actions, type InitSuccessActionData, type UpdateCartActionData } from "./actions";
import { type Cart } from "./types";

const reducer = (state: Cart.State, action: ReduxAction<any>): Cart.State => {
  switch (action.type) {
    case Actions.InitBegin: {
      return {
        ...state,
        status: Status.Loading
      };
    }
    case Actions.InitFailure: {
      return {
        ...state,
        status: Status.Failed
      };
    }
    case Actions.InitSuccess: {
      const { checkoutUrl, currencyCode, items, shouldDisplayTax } = action.data as InitSuccessActionData;
      return {
        ...state,
        checkoutUrl,
        currencyCode,
        cart: {
          items
        },
        shouldDisplayTax,
        status: Status.Ready
      };
    }

    case Actions.CheckoutBegin: {
      return {
        ...state,
        status: Status.Saving
      };
    }
    case Actions.CheckoutFailure: {
      const { error } = action.data as FailureActionData;
      return {
        ...state,
        error,
        status: Status.Ready
      };
    }

    case Actions.UpdateCart: {
      const { cart } = action.data as UpdateCartActionData;
      return {
        ...state,
        cart
      };
    }

    case Actions.RemoveFromCartBegin: {
      return {
        ...state,
        status: Status.Saving
      };
    }
    case Actions.RemoveFromCartFailure: {
      const { error } = action.data as FailureActionData;
      return {
        ...state,
        error,
        status: Status.Ready
      };
    }
    case Actions.RemoveFromCartSuccess: {
      return {
        ...state,
        status: Status.Ready
      };
    }

    default:
      return state;
  }
};

export const defaultState: Cart.State = {
  error: null,
  id: "",
  currencyCode: "",
  status: Status.None,
  checkoutUrl: "",
  cart: {
    items: []
  },
  shouldDisplayTax: false
};
export const previewState: Cart.State = {
  error: null,
  id: "",
  currencyCode: "USD",
  status: Status.Ready,
  checkoutUrl: "",
  cart: {
    items: [
      {
        availableQuantity: 1,
        children: [],
        description: "Dummy",
        id: "",
        imageUrl: null,
        name: "Dummy",
        originalPrice: 100,
        permalink: "/",
        price: 100,
        productId: "",
        quantity: 1,
        subname: "Dummy",
        subscriptionInfo: null,
        taxPercentage: 0
      }
    ]
  },
  shouldDisplayTax: false
};
export default wrapReducer({ defaultState, reducer, previewState });
